import React from "react";
import {
  AllInboxOutlined,
  Dashboard,
  PeopleOutline,
  PsychologyOutlined,
  Timeline,
  Inventory2Outlined,
  PeopleAltOutlined,
  SupervisorAccount,
  HubOutlined,
  AccountTreeOutlined,
  AltRouteOutlined,
  BusinessOutlined,
  SettingsSuggestOutlined,
  PaymentOutlined,
  LocalShippingOutlined,
  CategoryOutlined,
  LocalOfferOutlined,
  LabelOutlined,
  StairsOutlined,
  CollectionsOutlined,
  ArticleOutlined,
  PolicyOutlined,
  QuestionAnswerOutlined,
  PollOutlined,
  SmartToyOutlined,
  IntegrationInstructionsOutlined,
  Translate,
  CampaignOutlined,
  ConfirmationNumberOutlined,
  LocationCityOutlined,
  TuneOutlined,
  DesktopWindowsOutlined,
  AccessTimeOutlined,
} from "@mui/icons-material";
import { WorkspaceSegments } from "../constants/workspaceSegments";

const campaignsMenuItem = {
  textKey: "nav.campaigns",
  label: "Campanhas",
  icon: <AltRouteOutlined />,
  link: "/campaigns",
  res: "campaigns",
};

const paidAdsSettingsItem = {
  textKey: "nav.paidAds",
  icon: <CampaignOutlined />,
  link: "/settings/paid-ads",
  res: "paid_ads",
};

export const myTimeClockNavItem = {
  textKey: "nav.myTimeClock",
  label: "Meu Ponto",
  icon: <AccessTimeOutlined />,
  link: "/meu-ponto",
  res: "time_clock",
};

/** Itens do menu da foto (não entram no menu principal). */
export const profileNavItemsDef = [myTimeClockNavItem];

export const menuItemsDef = [
  { textKey: "nav.dashboard", icon: <Dashboard />, link: "/dashboard/live", match: "/dashboard", res: "dashboard" },
  { textKey: "nav.chat", icon: <AllInboxOutlined />, link: "/chat", res: "chat" },
  { textKey: "nav.salesPipeline", icon: <Timeline />, link: "/sales-pipeline", res: "sales_pipeline" },
  { textKey: "nav.clients", icon: <PeopleOutline />, link: "/clients", res: "clients" },
  { textKey: "nav.surveys", label: "Pesquisas", icon: <PollOutlined />, link: "/surveys", res: "surveys" },
  { textKey: "nav.awareness", icon: <PsychologyOutlined />, link: "/pipeline", res: "awareness" },
  { textKey: "nav.products", icon: <Inventory2Outlined />, link: "/products", res: "products" },
  {
    textKey: "nav.passagens",
    icon: <ConfirmationNumberOutlined />,
    link: "/passagens",
    res: "passagens",
    segments: [WorkspaceSegments.PassengerTransport],
  },
  campaignsMenuItem,
];

// Ordem: equipe e empresa → canais/atendimento → integrações e idioma → automação/risco → pagamento/entrega/tags → catálogo e conteúdo → funil → parametrização (master).
export const settingsItemsDef = [
  { textKey: "nav.companies", icon: <BusinessOutlined />, link: "/settings/companies", res: "companies" },
  { textKey: "nav.users", icon: <PeopleAltOutlined />, link: "/settings/users", res: "users" },
  { textKey: "nav.positions", icon: <SupervisorAccount />, link: "/settings/positions", res: "positions" },
  { textKey: "nav.virtualOffice", label: "Escritório Virtual", icon: <DesktopWindowsOutlined />, link: "/settings/virtual-office", res: "virtual_office" },
  { textKey: "nav.timeClock", label: "Controle de Ponto", icon: <AccessTimeOutlined />, link: "/settings/time-clock", res: "time_clock" },
  { textKey: "nav.channels", icon: <HubOutlined />, link: "/settings/channels", res: "channels" },
  { textKey: "nav.types", icon: <AccountTreeOutlined />, link: "/settings/types", res: "types" },
  {
    textKey: "nav.passengerCities",
    icon: <LocationCityOutlined />,
    link: "/passenger-cities",
    res: "cities",
    segments: [WorkspaceSegments.PassengerTransport],
  },
  { textKey: "nav.chatbots", icon: <QuestionAnswerOutlined />, link: "/chatbots", res: "chatbot" },
  { textKey: "nav.agents", icon: <SmartToyOutlined />, link: "/agents", res: "agents" },
  { textKey: "nav.integrations", icon: <IntegrationInstructionsOutlined />, link: "/settings/integrations", res: "integrations" },
  paidAdsSettingsItem,
  { textKey: "nav.workspaceLanguage", icon: <Translate />, link: "/settings/workspace-language", res: "workspace_i18n" },
  { textKey: "nav.automationRules", icon: <SettingsSuggestOutlined />, link: "/settings/automation-rules", res: "automation_rules" },
  { textKey: "nav.antifraudMethods", icon: <PolicyOutlined />, link: "/settings/antifraud-methods", res: "antifraud_methods" },
  { textKey: "nav.paymentMethods", icon: <PaymentOutlined />, link: "/settings/payment-methods", res: "payment_methods" },
  { textKey: "nav.deliveryMethods", icon: <LocalShippingOutlined />, link: "/settings/delivery-methods", res: "delivery_methods" },
  { textKey: "nav.clientTags", icon: <LabelOutlined />, link: "/settings/client-tags", res: "client_tags" },
  { textKey: "nav.categories", icon: <CategoryOutlined />, link: "/categories", res: "categories" },
  { textKey: "nav.coupons", icon: <LocalOfferOutlined />, link: "/coupons", res: "coupons" },
  { textKey: "nav.banners", icon: <CollectionsOutlined />, link: "/banners", res: "banners" },
  { textKey: "nav.contents", icon: <ArticleOutlined />, link: "/contents", res: "contents" },
  { textKey: "nav.awarenessStages", icon: <StairsOutlined />, link: "/awareness-stages", res: "awareness_stages" },
  {
    textKey: "nav.platformConfigurations",
    icon: <TuneOutlined />,
    link: "/settings/configurations",
    res: "companies",
    masterOnly: true,
  },
];

